import { Component, HostBinding } from '@angular/core';
import { AddDocumentComponent } from '../add-document/add-document.component';
import { MatDialog } from '@angular/material/dialog';
import { UploadDocumentComponent } from '../upload-document/upload-document.component';
import { AddDocumentPackComponent } from '../add-document-pack/add-document-pack.component';
import { AddUsefulDocumentComponent } from '../add-useful-document/add-useful-document.component';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { DocumentService } from 'src/app/services/document/document.service';
import { P } from '@angular/cdk/keycodes';
import { AppService } from 'src/app/services/app/app.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';
import { ViewFolderComponent } from '../view-folder/view-folder.component';
import { CookieService } from 'ngx-cookie-service';
import { PaginationInstance } from 'ngx-pagination';
import { Filter } from '../../filter/filter.model';
import { CommonService } from 'src/app/services/common/common.service';
import { ViewDocumentsComponent } from '../view-documents/view-documents.component';
import { ViewSignedContractsComponent } from '../view-signed-contracts/view-signed-contracts.component';
import { ViewContractDocumentComponent } from '../view-contract-document/view-contract-document.component';

@Component({
  selector: 'app-document-dashboard',
  templateUrl: './document-dashboard.component.html',
  styleUrls: ['./document-dashboard.component.scss']
})
export class DocumentDashboardComponent {
  @HostBinding('class.main-box') get applyClass() {
    return this.isAdmin;
  }
  public docType: string = "useful_document";
  public contractArr:any[]=[]
  public usefulDocArr: any[] = []
  public packArr: any[] = []
  public userArr: any[] = [ ]
  public empList: any[] = []
  public packDocDetail: any;
  public isSpinnerLoading: boolean = false;
  public imageURL: string = GlobalService.imageURL;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  popoverContent = `<button class="btn btn-success btn-yes" (click)="handleYes()">Yes</button>
  <button class="btn btn-danger btn-no" (click)="handleNo()">No</button>`;
  public packId!: number;
  public empCourseData: any;
  public companyId!: string;
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public count!: number;
  public isAdmin:boolean=false;
  public selectedEmployeeId!:string;
  public isFilterShow :boolean=false;
  public filterObj:Filter={
    operand:"or",
    arr:[]
  }
  public filterArr:any[]=[
    { key_name: "First Name", key_val: "f_n", type: 'text' },
    { key_name: "Last Name", key_val: "l_n", type: 'text' },
    // { key_name: "Department", key_val: "department", type: 'select' },
  ]
  public searchInput: string = '';
  private previousInputValue: string = '';
  public baseUrl!:string;
  constructor(private dialog: MatDialog, private docService: DocumentService, private appService: AppService, private cookieService: CookieService,
  private userManagementService: UserManagementService, private commonService: CommonService) { }

  ngOnInit(): void {
    this.commonService.setTitle("Document Management")
    this.checkUserType()
     this.onDocType(this.docType)
  }
  checkUserType() {
    // if( this.cookieService.get('user_id') && window.location.href.includes('doc-dashboard') ){
    if (this.cookieService.get('user_id')) {
      // whenever admin user set the token of admin 
      this.appService.storeData('training-portal.admin-authToken', this.cookieService.get('user_id'));
      this.appService.storeSessionData('isAdmin', JSON.stringify(true));
      this.companyId = this.cookieService.get('company_id')
       this.isAdmin=true;
    }
    else {
      let obj = JSON.parse(this.appService.getData('training-portal.userInfo'))
      this.companyId = obj.company_id
    }
  }
  callApi(obj){
    this.filterObj=obj
    this.callAPI()
  }
  onFilterView(){
    this.isFilterShow=!this.isFilterShow
  }
  onDocType(value: string) {
    this.docType = value
    this.config.currentPage=1;
    this.config.itemsPerPage=this.pageSizeOptions[0]
    if (this.docType == 'action_document') {
      
      this.getPackList()
    }
    if (this.docType == 'course_document') {
      this.getEmployeeList()
    }
    if (this.docType == 'useful_document') {
      this.isFilterShow=false;
      this.usefulDocList()
    }
    if (this.docType == 'contract_document') {
      this.isFilterShow=false;
      this.contractDocList()
    }
  }
  callAPI(){
    if (this.docType == 'action_document') {
      this.getPackDocList(this.packId)
    }
    else if (this.docType == 'course_document') {
      this.getEmployeeList()
    }
    else if (this.docType == 'contract_document') {
      this.contractDocList()
    }
    else  {
      this.usefulDocList()
    }
  }
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1
    this.callAPI()
    // this.onDocType(this.docType)
    // this.getPackDocList(this.packId)
  }
  onPageChange(number: number) {
    this.config.currentPage = number
    this.callAPI()
    // this.onDocType(this.docType)
    // this.getPackDocList(this.packId)
  }
  onDownload(item: string) { }
  onAddNewDocument() {
    const dialogRef = this.dialog.open(AddDocumentComponent, {
      width: '60%', minWidth: '280px', height: '90%', maxHeight: '700px',maxWidth:'800px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      data: { isDocFromDashboard: true, pack_id: this.packId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        this.getPackDocList(this.packId)
      }
    });
  }
  onAddNewDocumentPack() {
    const dialogRef = this.dialog.open(AddDocumentPackComponent, {
      width: '70%', minWidth: '300px', maxWidth:'796px',height: '80%', maxHeight: '740px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        this.getPackList()
      }
    });
  }
  onEditPack() {
    const dialogRef = this.dialog.open(AddDocumentPackComponent, {
      width: '60%', minWidth: '280px', height: 'auto', maxHeight: '90vh',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      data: { pack_id: this.packId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        this.getPackList()
      }
    });
  }
  onUploadDoc(e_id: number, val: any, item,index:number) {
    let docName = this.packDocDetail.doc.filter(item => item["id"] == val.doc_id)[0]["d_n"]
    let data = {
      e_id: e_id,
      pack_id: val.pack_id,
      doc_id: val.doc_id,
      data: val.data,
      e_data: item,
      doc_name: docName,
      d_tp:this.isSignDoc(index,item.doc_id)
    }
    const dialogRef = this.dialog.open(UploadDocumentComponent,{
        width: '50%', minWidth: '300px', height: '90%', maxWidth:'600px',maxHeight: '700px', enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
        panelClass: "hire", autoFocus: false, data: data })
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        this.getPackList()
      }
    });
  }
  onDeleteItem(id: string | number) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: this.docType, id: id }
    },));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        if(this.docType=="action_document"){
          this.getPackList()
        }
        else{
          this.callAPI()
        }
      //  this.callAPI()
      }
    });
  }
  onSelDocPack(item) {
    item.selected = true;
    // Set the selected property to false for all other items
    this.packArr.forEach(i => {
      if (i !== item) {
        i.selected = false;
      }
    });
    this.packId = item.id
    this.getPackDocList(item.id)
  }
  onAddUseDocument() {
    const dialogRef = this.dialog.open(AddUsefulDocumentComponent, {
      width: '80%', minWidth: '300px', height: '98%', maxHeight: '850px', maxWidth: "668px",
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      autoFocus:false,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        this.usefulDocList()
      }
    });
  }
  contractDocList(){
    this.isSpinnerLoading = true;
    let obj={
    st:this.appService.startPageLogic( this.config.currentPage,this.config.itemsPerPage),
    r_p:this.config.itemsPerPage,
    sh:this.searchInput,
    op_nd:this.filterObj.operand,
    f_a:[],
    co_i:this.companyId,
    }
    this.docService.contractDocumentList(obj).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          this.baseUrl=success.base;
          this.contractArr = [];
          this.contractArr = success["msg"];
          this.count = success.count;
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  usefulDocList() {
    this.isSpinnerLoading = true;
    let obj={
      st:this.appService.startPageLogic( this.config.currentPage,this.config.itemsPerPage),
      r_p:this.config.itemsPerPage,
      sh:this.searchInput,
      op_nd:"",
      f_a:[],
      co_i:this.companyId,
    }
    this.docService.usefulDocumentList(obj).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          this.previousInputValue=this.searchInput
          this.usefulDocArr = [];
          this.usefulDocArr = success["data"];
          this.count = success.count;
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  getPackList() {
    this.isSpinnerLoading = true;
    // if(this.companyId){}
    this.packArr = []
     //if no pack then delete all the user data & pack related data
    this.userArr = []
    this.packDocDetail =''
    this.count = 0
    this.docService.getPackList(this.companyId).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200 && success.msg.length > 0) {
          this.packArr = [];
          this.packArr = success.msg;
          if (this.packArr.length > 0) {
            this.packArr.map((item) => (item["selected"] = ""));
            this.packArr[0].selected = true;
            this.packId = this.packArr[0]["id"];
            this.getPackDocList(this.packId);
          }
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  getPackDocList(id) {
    let dataObj = {
      "pack_id": id,
      "r_p": this.config.itemsPerPage,
      "st": this.appService.startPageLogic( this.config.currentPage,this.config.itemsPerPage),
      sh:this.searchInput,
      f_a:this.filterObj.arr,
      op_nd:this.filterObj.operand,
      search:''
    }
    this.userArr = []
    this.isSpinnerLoading = true;
    this.docService.getAllPackDoc(dataObj).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.previousInputValue=this.searchInput
          this.isSpinnerLoading = false;
          this.userArr = success.msg.u_d;
          this.packDocDetail = success.msg;
          this.count = success.msg.count;
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  onFile(baseUrl,document){

    let URL = baseUrl+document;
    this.appService.downloadFile(URL, 'contract-document')
  }
  onFileDownload(data: string) {
      this.appService.downloadFile(data, 'useful-document')
  }
  onSelectActionUser(item){
    if(window.innerWidth > 576){
      item.selected = true;
    }
    else{
      //for smaller devices arrow up/down is shown hence negate the selected property
      item.selected=!item.selected
    }
     // Set the selected property to false for all other items
    this.userArr.forEach(i => {
      if (i !== item) {i.selected = false;}
    });
    // this.selectedEmployeeId=item.e_id
  }
  onSelectUser(item: any) {
    if(window.innerWidth > 576){
      item.selected = true;
    }
    else{
      //for smaller devices arrow up/down is shown hence negate the selected property
      item.selected=!item.selected
    }
     // Set the selected property to false for all other items
    this.empList.forEach(i => {
      if (i !== item) {i.selected = false;}
    });
    this.selectedEmployeeId=item.e_id
    this.getEmpCourseWork(0, item.e_id)
  }
  getEmployeeList() {
    this.isSpinnerLoading = true;
    let obj={
      st:this.appService.startPageLogic( this.config.currentPage,this.config.itemsPerPage),
      r_p:this.config.itemsPerPage,
      sh:"",
      op_nd:this.filterObj.operand,
      f_a:this.filterObj.arr,
      co_i:this.companyId
    }
    this.docService.getEmpList(obj).subscribe({
      next: (success: any) => {
        this.isSpinnerLoading = false;
        if (success.status == 200) {
          this.empList = [];
          this.count = success.count;
          if (typeof success.msg != "string") {
            this.empList = success.msg;
            this.empList.map((item) => {
              item["selected"] = "";
            });

            if (this.selectedEmployeeId) {
              this.getEmpCourseWork(0, this.selectedEmployeeId);
              if (window.innerWidth > 576) {
                let index = this.empList.findIndex(
                  (item) => item.e_id == this.selectedEmployeeId
                );
                this.empList[index].selected = true;
              }
            } else {
              this.getEmpCourseWork(0, this.empList[0].e_id);
              if (window.innerWidth > 576) {
                this.empList[0].selected = true;
              }
            }
          }
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  getEmpCourseWork(f_id, e_id) {

    console.log(e_id.f_id)

    this.isSpinnerLoading = true;
    this.docService.getEmpCourseWork(f_id, e_id).subscribe({
      next: (result: any) => {
        this.isSpinnerLoading = false;
        if (result.status == 200) {
          this.empCourseData = result.data.listing;
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false;
        this.commonService.handleError(error);
      },
    });
  }
  onViewFolder(id: string, e_id: string) {
    const dialogRef = this.dialog.open(ViewFolderComponent, {
      width: '60%', minWidth: '280px', height: 'auto', maxHeight: '90vh',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      data: { folder_id: id, e_id: e_id }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
      }
    });
  }
  isSignDoc(d_id:number,udoc_id:string){
   if((this.packDocDetail["doc"][d_id].d_tp==1)){
    return true
   }
   else{return false;}
  }
  onAddContract(){
    let data={}
    this.docService.addContract(data).subscribe((result)=>{
          if(result.status==200){
            var newWindow = window.open(result.data.url, '_blank', 'height=700,width=700');
          }
        })
  }
  onViewDocument(item){
    const dialogRef = this.dialog.open(ViewDocumentsComponent, {
      width: '50%', minWidth: '280px', height: 'auto', maxHeight: '90vh', maxWidth: "868px",
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      autoFocus:false,data:item
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        // this.usefulDocList()
        
      }
    });
  }
  onViewSignedContract(item){
    let obj={
      id:item.document_id
    }
    const dialogRef = this.dialog.open(ViewSignedContractsComponent, {
      width: '50%', minWidth: '280px', height: 'auto', maxHeight: '90vh', maxWidth: "868px",
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
      autoFocus:false,data:obj
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        // this.usefulDocList()
        
      }
    });
  }
  onGo(){
    if(this.searchInput.trim()!=''){
      this.config.currentPage=0
      this.onDocType(this.docType)
    }
  }
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.config.currentPage=0
      this.onDocType(this.docType)
    }
  }
  onViewContractDoc(item){
    const dialogRef = this.dialog.open(ViewContractDocumentComponent, {
      width: '60%', minWidth: '280px', height: '90%', maxHeight: '700px',maxWidth:'800px',
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", panelClass: "hire",
       data:this.baseUrl+item.document
       
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["data_added"] == true) {
        // this.getPackDocList(this.packId)
      }
    });
  }
}
